import { graphql } from '@apollo/client/react/hoc';
import { DocumentNode } from 'graphql';

function formMutation(mutation: DocumentNode) {
  return graphql(mutation, {
    name: 'formUpdate',
  });
}

export default formMutation;
